export default "__VITE_ASSET__cb64ff3a__"